// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
/*(function ($, Drupal, once) {
  Drupal.behaviors.tablesawVboFix = {
    attach: function (context, settings) {
      // Wir binden den Event-Handler an das Dokument, aber nur einmal.
      $(once('vbo-tablesaw-init', 'html', context)).each(function () {

        $(document).on('tablesawcreate', function (event) {
          // Das Element, das das Event ausgelöst hat (die Tabelle)
          var $table = $(event.target);

          if ($table.length && $table.is('table')) {
            // Verhindere Endlosschleife: Prüfe, ob wir diese Tabelle
            // in diesem Durchgang schon repariert haben.
            $(once('vbo-repaired', $table)).each(function () {

              // WICHTIG: Ein kleiner Timeout (50ms) lässt Tablesaw erst mal
              // seine Arbeit komplett beenden, bevor Drupal reingrätscht.
              setTimeout(function () {
                console.log('Tablesaw fertig. Repariere VBO AJAX für Tabelle:', $table[0]);

                // Wir führen attachBehaviors NUR für die Tabelle aus.
                // Um die Endlosschleife zu verhindern, nutzen wir context.
                Drupal.attachBehaviors($table[0], settings);
              }, 50);

            });
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
*/
